'use client';

import { useState, useContext, useMemo } from 'react';

import MenuMobile from '@/components/MenuMobile';
import Navigation from '@/components/Navigation';
import ScreenWidthContext from '@/contexts/ScreenWidthContext';
import { NavigationItem } from '@/utils/types/api';

import { Props } from './types';

const MenuWrapper = ({ data, contactData }: Props) => {
  const [closed, setIsClosed] = useState(false);
  const { isMobile, screenWidth } = useContext(ScreenWidthContext);
  const [isSubMenuOpened, setIsSubMenuOpened] = useState(false);
  const [subMenuParent, setSubMenuParent] = useState<NavigationItem>();

  const openSubMenu = (menuItem: NavigationItem) => {
    setIsSubMenuOpened(true);
    setSubMenuParent(menuItem);
  };

  const closeSubMenu = () => {
    setIsSubMenuOpened(false);
    setIsClosed(false);
  };

  const openNavMenu = () => {
    setIsClosed(false);
  };

  const closeNavMenu = () => {
    setIsClosed(true);
  };

  const content = useMemo(() => {
    if (isMobile) {
      return (
        <MenuMobile
          data={data}
          contactData={contactData}
          openSubMenu={openSubMenu}
          closeSubMenu={closeSubMenu}
          isSubMenuOpened={isSubMenuOpened}
          subMenuParent={subMenuParent}
          isMobile={isMobile}
          openNavMenu={openNavMenu}
          closeNavMenu={closeNavMenu}
          isClosedMobileNav={closed}
        />
      );
    } else {
      return (
        <Navigation
          data={data}
          openSubMenu={openSubMenu}
          closeSubMenu={closeSubMenu}
          isSubMenuOpened={isSubMenuOpened}
          subMenuParent={subMenuParent}
          isMobile={isMobile}
          openNavMenu={openNavMenu}
          closeNavMenu={closeNavMenu}
          isClosedMobileNav={closed}
        />
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isSubMenuOpened, subMenuParent, closed]);

  return (
    <span onMouseLeave={closeSubMenu} key={isMobile ? 'mobile' : 'desktop'}>
      {screenWidth && content}
    </span>
  );
};

export default MenuWrapper;
